import { FormikGenericDatePickerFactory } from './FormikGenericDatePicker'
import { GenericDatePickerFactory } from './GenericDatePicker'
import { dateToGraphQLDate, graphQLDateToDate } from './helpers'

export const GraphQLDatePicker = GenericDatePickerFactory<any>({
  mapDateToValue: dateToGraphQLDate,
  mapValueToDate: graphQLDateToDate,
})

export const FormikGraphQLDatePicker =
  FormikGenericDatePickerFactory(GraphQLDatePicker)
